import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrganizationManagementService } from './organization-management.service';
import { Organization } from '../../_models/organization';

@Injectable({
  providedIn: 'root'
})
export class OrgInterceptorService implements HttpInterceptor{

  private currentOrg: Organization;

  constructor(private orgs: OrganizationManagementService) {
    this.orgs.observeOrganization().subscribe(o => {
      this.currentOrg = o;
    })
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req;

    if (this.currentOrg && this.currentOrg.id ) {
      request = req.clone({
        setHeaders: {
          'X-Auth-Organization': this.currentOrg.id
        }
      })
    }

    return next.handle(request);

  }
}
